import { Cubit } from "blac-next";
import { Step } from "src/ui/components/StepList/StepList";
import { tracker, userPreferences } from "src/state/state";
import expectationManagementSteps from "src/constants/expectationManagementSteps";
import { UserPreferenceKeys } from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { addContextToExpectationManagementStep } from "src/lib/addContextToExpectationManagementStep";
import { CaourselStepChangeDetails } from "molecule/carousel/CarouselCubit";

export type ExpectationsManagementScreenState = {
  steps: Step[];
};

export class ExpectationsManagementScreenBloc extends Cubit<ExpectationsManagementScreenState> {
  constructor() {
    super({
      steps: []
    });
  }

  configure = (options: {
    userExperienceGroup: Parameters<
      ExpectationsManagementScreenBloc["setGroup"]
    >[0];
    callbacks: Parameters<ExpectationsManagementScreenBloc["setCallbacks"]>[0];
  }) => {
    this.setGroup(options.userExperienceGroup);
    this.setCallbacks(options.callbacks);
    this.trackInitialView();
  };

  trackedInitial = false;
  private trackInitialView() {
    const experienceGroup = this.userExperienceGroup;

    if (!experienceGroup) {
      return;
    }

    if (!this.trackedInitial) {
      tracker.track("Expectation Management Screen Viewed", {
        data: { userExperienceGroup: experienceGroup }
      });
      this.trackedInitial = true;
    }
  }

  callbacks: { onDismiss: () => void } | null = null;
  setCallbacks = (callbacks: { onDismiss: () => void }) => {
    this.callbacks = callbacks;
  };

  userExperienceGroup: string | undefined;
  setGroup = (userExperienceGroup: string | undefined) => {
    if (this.userExperienceGroup === userExperienceGroup) {
      return;
    }

    this.userExperienceGroup = userExperienceGroup;

    const steps = addContextToExpectationManagementStep(
      expectationManagementSteps,
      userExperienceGroup
    );

    this.patch({ steps });
  };

  handleDismissScreen = (triggerName: string) => {
    this.callbacks?.onDismiss();
    void userPreferences.updateUserPreferences({
      [UserPreferenceKeys.showManagementExpectation]: false
    });
    tracker.track("Expectation Management Screen Dismissed", {
      data: { trigger: triggerName }
    });
  };

  handleStepChange = (index: number, details: CaourselStepChangeDetails) => {
    tracker.track(`Expectation Management Step Changed`, {
      data: {
        stepIndex: index,
        stepName: details.stepName,
        carouselId: details.carouselId,
        carouselLabel: details.carouselLabel
      }
    });
  };
}
